import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { ApiService } from '../../../../shared/services/api.service';
import { CartService } from '../../../../shared/services/cart.service';

import { Pcategory, Product, ProductOrder, Poptional, PoptionalSelection, Pizza, PizzaConfig } from '../../../../shared/models';
import { Utils } from '../../../../shared/helpers/utils';

import { environment } from '../../../../../environments/environment';

import { faCartShopping, faPlus, faMinus } from '../../../../icons';

@Component({
    selector: 'app-product-details',
    templateUrl: './product-details.component.html',
    styleUrls: ['./product-details.component.scss'],
    standalone: false
})
export class ProductDetailsComponent implements OnInit {
	@Input() product: Product;
  @Input() isPizza: boolean;
  @Input() pizzaConfig: PizzaConfig;
  @Input() pizzaCategories: Pcategory[] = [];

	@Output() onItemAdded: EventEmitter<ProductOrder> = new EventEmitter();

	item: ProductOrder;
  adding: boolean = false;
  poptionals: Poptional[] = [];
  // starts true whenever poptionals will be fetched, so addProduct() can't
  // slip through the "no poptionals" branch before the fetch resolves
  loadingPoptionals: boolean = false;

  serverUrl: string = environment.server_url;

  faCartShopping = faCartShopping;
  faPlus = faPlus;
  faMinus = faMinus;

  constructor(private api: ApiService,
  	private cart: CartService) {
  }

  ngOnInit(): void {
  	this._init();
    if(!this.isPizza || !this.pizzaConfig) {
      this._loadPoptionals();
    }
    window.scrollTo(0,0);
  }

  addNote() {
  	this.item.notes_obj.push({
  		text: ''
  	});
    setTimeout(() => {
      let notesEl = document.getElementsByName("note-text");
      notesEl[notesEl.length - 1].focus();
    }, 100);
  }
  removeNote(index) {
  	this.item.notes_obj.splice(index, 1);
  }

  addProduct() {
    // poptionals may still be loading (async fetch): don't let the item
    // through the "no poptionals" branch until we actually know whether
    // there are required choices to make
    if(this.loadingPoptionals) {
      return;
    }
    if(this.poptionals.length > 0) {
      this.adding = true;
    } else {
      this.done();
    }
  }
  done(selectedPoptionals: PoptionalSelection[]|null = null) {
    let aux_item = this._prepareItem(selectedPoptionals);
  	this.cart.addItem(aux_item);
  	this.onItemAdded.emit(aux_item);
  }

  onPizzaDone(pizza: Pizza) {
    const ids = pizza.flavorProductIds || [];
    const productId = ids[0] || this.product.id;
    let product = this.product;
    for(let cat of this.pizzaCategories || []) {
      const found = (cat.products || []).find(p => p.id == productId);
      if(found) {
        product = found;
        break;
      }
    }
    const text = pizza.textRepresentation();
    const item = <ProductOrder>{
      product_id: product.id,
      product: product,
      quantity: 1,
      custom_price: Number(pizza.total).toFixed(2),
      notes: text,
      notes_obj: [{ text: text }],
      poptional_selections: []
    };
    ProductOrder.setAdditionalData(item);
    this.cart.addItem(item);
    this.onItemAdded.emit(item);
  }

  back() {
    this.onItemAdded.emit(null);
  }

  checkEnter(event) {
    // event.key can be undefined on some keydown events (autofill, IME
    // composition, some mobile keyboards)
    if((event.key || '').toLowerCase() == 'enter')
      this.addNote();
  }

  private _loadPoptionals() {
    this.poptionals = [];
    this.loadingPoptionals = true;
    this.api.indexAll('poptionals', {
      q: {
        pcategory_id: this.product.pcategory_id,
        hidden: false
      }
    }).subscribe(
      res => {
        this.poptionals = Poptional.fromJsonArray(res.poptionals);
        this.loadingPoptionals = false;
      },
      err => {
        console.log(err);
        this.loadingPoptionals = false;
      }
    );
  }
  private _init() {
  	this.item = <ProductOrder> {
  		product_id: this.product.id,
  		product: this.product,
  		notes_obj: [{
  			text: ''
  		}],
  		quantity: 1
  	}
  }
  private _prepareItem(poptionalSelections: PoptionalSelection[] = []): ProductOrder {
    let it = this.item;

    for(let i = 0; i < it.notes_obj.length; i++) {
      let note = it.notes_obj[i];
      if(note.text.length == 0) {
        it.notes_obj.splice(i, 1);
        i--;
      }
    }
    it.created_at = Utils.dateToISO(new Date());
    it.poptional_selections = poptionalSelections;
    ProductOrder.setAdditionalData(it);
    return it;
  }
}
